import {
  ShiftCreateRequest,
  ShiftInputs,
  ShiftUpdateRequest,
} from '../../../types/app/shifts.types';

export const convertDataFromInputToCreateRequest = (data: ShiftInputs): ShiftCreateRequest => ({
  id: data.id,
  end: data.end,
  start: data.start,
  name: data.name,
});

export const convertDataFromInputToUpdateRequest = (data: ShiftInputs): ShiftUpdateRequest => ({
  id: data.id!,
  start: data.start,
  name: data.name,
  end: data.end,
});
